export default __webpack_public_path__ + "static/media/item-1.2d365bdb.webp";